import React, { useEffect } from 'react';
import { Controller,useForm } from 'react-hook-form';
import UploadFile from '../../UploadFile/UploadFile';

const StepTwo = ({prevStep,nextStep,paiement,setPaiement}) => {
  const { 
    handleSubmit,
    formState: { errors },
    setError: setFormError,
    control,
    trigger,
    clearErrors,
    setValue,
  } = useForm(); 
  const handleNext = (data) => {
    nextStep();
  }

  useEffect(() => {
    setValue("files", paiement?.infovehicule?.dossier || []);
    if (paiement?.infovehicule?.dossier?.length > 0) {
      clearErrors("files");
    } else {
      trigger("files");
    }
  }, [paiement.infovehicule.dossier, setValue, clearErrors, trigger]);
 // console.log(errors)
  return (
    <div className='step-component step-two'>
     <form onSubmit={handleSubmit(handleNext)}>
       <Controller
           name="files"
          control={control}
          rules={{
            validate: value => ((value && value?.length > 0 || paiement.infovehicule.loadedDossier?.length > 0)) || "Vous devez uploader un fichier PDF"
          }}
          render={({ field, fieldState: { error } }) => (
            <UploadFile 
              paiement={paiement}
              setPaiement={setPaiement}
              formError={error}
              onFilesChange={(files) => {
                field.onChange(files);
                if (files && files.length > 0) {
                  clearErrors("files");
                  setPaiement(prev => ({
                    ...prev,
                    infovehicule: {
                      ...prev.infovehicule,
                      dossier: files
                    }
                  }));
                }
              }}
            />
           )}
         />
        
        {errors.files && (
          <div className="error-message" style={{ color: 'red', marginTop: '10px' }}>
            {errors.files.message}
          </div>
        )}
       <div className="buttons">
          <button className="secondary" onClick={prevStep} type="button">
            Précedent
          </button>
          <button className="" type='submit'>
            Suivant
          </button>
       </div>
      </form>
    </div>
  )
}

export default StepTwo